import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import { MenuList, MenuListItemType, MenuListItemVariant } from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import { useMemo } from "react";
import { ReactRouterLinkWrapper } from "@/components/MenuList/ReactRouterLinkWrapper";
import useAssociatedDevices from "@/hooks/useAssociatedDevices";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";

const ElementSection = ({ profile }: { profile?: WSMWorkoutProfile }) => {
  const { hasAssociated1st2ndGenBolt, hasAssociated1st2ndGenRoam } = useAssociatedDevices();

  const ledsEnabled = hasAssociated1st2ndGenBolt || hasAssociated1st2ndGenRoam;

  const sectionItems = useMemo(
    () =>
      [
        {
          id: "plannedWorkouts",
          content: t`Planned workouts`,
          variant: MenuListItemVariant.InternalLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/planned-workout-settings`,
          linkComponent: ReactRouterLinkWrapper,
        },
        {
          id: "stravaLiveSegments",
          content: t`Strava Live Segments`,
          variant: MenuListItemVariant.InternalLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/strava-live-segment-settings`,
          linkComponent: ReactRouterLinkWrapper,
        },
        {
          id: "summitSegments",
          content: t`Summit Segments`,
          variant: MenuListItemVariant.InternalLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/summit-segment-settings`,
          linkComponent: ReactRouterLinkWrapper,
        },
        {
          id: "leds",
          content: t`LEDs`,
          variant: MenuListItemVariant.InternalLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/led-settings`,
          linkComponent: ReactRouterLinkWrapper,
          hidden: !ledsEnabled,
        },
      ] as MenuListItemType[],
    [ledsEnabled, profile?.external_id]
  );

  const isCyclingProfile = useMemo(
    () => profile?.workout_type_family_id === WahooWorkoutTypeFamily.Cycling,
    [profile?.workout_type_family_id]
  );

  if (!isCyclingProfile) {
    return undefined;
  }

  return <MenuList title={t`On your ELEMNT`} variant="elevation" listItems={sectionItems} />;
};

export default ElementSection;
